import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchPackageType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";

const PackageDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const dispatch = useDispatch();

  const packageName =
    rowData?.package_obj?.package_name ||
    rowData?.package_type ||
    getValues()?.Package_type;
  const packageId =
    rowData?.package_obj?.id || rowData?.package_id || getValues()?.package_id;

  const selectedPackageId = watch("package_id");

  const {
    data: packageTypeList,
    isLoading,
    error,
  } = useQuery(["Package", selectedPackageId], () => fetchPackageType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(() => {
    return (
      packageTypeList?.data?.data?.map((pkg) => ({
        value: pkg.id,
        label: pkg.package_name,
      })) || []
    );
  }, [packageTypeList]);

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption =
        options.find((option) => option.value === rowData?.package_obj?.id) ||
        options.find((option) => option.value === rowData?.package_id?.id);
      if (selectedOption) {
        setValue("package_id", selectedOption.value);
        setValue("Package_type", selectedOption.label);
      }
    }
  }, [rowData, options, setValue]);

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedPackageId) ||
      options.find((option) => option.value === rowData?.package_id?.id) ||
      options.find((option) => option.value === packageId) ||
      options.find((option) => option.label === packageName) ||
      null
    );
  }, [options, selectedPackageId, packageId, packageName]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Package Types</div>;

  return (
    <Controller
      name="package_id"
      control={control}
      rules={{
        required: required ? "Package is required" : false,
        validate: (value) => {
          if (required && !value) return "Package is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Package Type"
          value={selectedOption || null}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              height: "42px",
            }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("package_id", value);
            setValue(
              "Package_type",
              selectedOption ? selectedOption.label : ""
            );
          }}
          className={`react-select-container ${
            errors.package_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default PackageDropDown;
